module.exports = __webpack_public_path__ + "static/media/ICONS_ESTILOS.ef9cc227.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_ESTILOS.svg
// module id = 482
// module chunks = 0